// Parse chuỗi search → order id NẾU trông giống mã đơn. Mã hiển thị ở danh sách
// là DH<id zero-pad 7> (formatOrderShortCode). Cho phép gõ:
//   - số trần: 18 / 018 / 0018 / 00018 → 18 (Number bỏ số 0 đầu)
//   - có tiền tố DH: DH18 / DH-0018 / dh 18 / DH0000018 → 18
// Có chữ (vd "Nguyễn 18") → null để KHÔNG phá search theo tên/SĐT.
export function parseOrderIdQuery(search: string): number | null {
  const s = search.trim()
  const m = s.match(/^dh[-\s]?(\d+)$/i) ?? s.match(/^(\d+)$/)
  if (!m) return null
  const id = Number(m[1])
  return Number.isSafeInteger(id) && id > 0 ? id : null
}
